export default __webpack_public_path__ + "static/media/business-288d.5148fb74.jpg";